<template>
    <input 
        ref="input"
        v-if="editing"
        v-model.number="number"
        @blur="editing = false"
        @keyup.enter="editing = false"
        type="text"
    />
    <span v-else @click="editing = true">
        {{value}}
    </span>
</template>

<script>
export default {
    name: 'editable-string',
    computed: {
        number: {
            get(){
                return this.value;
            },
            set(value) {             
                this.$emit('input', value);
            }
        }
    },
    watch: {
        editing(value) {
            const vm = this;
            if(value) {
                vm.$nextTick(function () {
                    vm.$refs.input.focus();
                });
            }
        }
    },
    data() {
        return {
            editing: false
        };
    },
    props: {
        value: {
            type: String,
            required: true
        }
    }
};
</script>
